export const EDITOR_SELECTORS = ['.tiptap', '.ElementSimpleContentEditable', '.DraftEditor-root'];
